export default function ua() {
	const browser = window.navigator.userAgent.toLowerCase();
	const body = document.body;

	// IEからアクセスされた場合
	if (browser.indexOf('msie') > 0 || browser.indexOf('trident') > 0) {
		body.setAttribute('data-ua', 'ie');
	}
	// Android端末からのアクセスの場合
	else if (browser.indexOf('android') > 0) {
		body.setAttribute('data-ua', 'android');
	}
}
